import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=1a8d6b78&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=ts"
export * from "./Signup.vue?vue&type=script&lang=ts"
import style0 from "./Signup.vue?vue&type=style&index=0&id=1a8d6b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8d6b78",
  null
  
)

export default component.exports